import { Pipe, PipeTransform } from '@angular/core';
import { GLOBAL_VARIABIALES } from '../constants/static-variable';

@Pipe({
  name: 'gst',
})
export class GstPipe implements PipeTransform {
  transform(price: number, args: any) {
    return args == '+'
      ? price + (price * 18) / 100
      : price - (price * 18) / 100;
    // name.split(' ').map(word => word.charAt(0).toUpperCase() + word.toLowerCase().slice(1)).join(' ');
  }
}
